import '.hj{margin:auto 4px;}.ssr-plugin'
import '.hk{height:calc(100% - 8px );}.ssr-plugin'
import '.hl{width:1px;}.ssr-plugin'
import '.hm{z-index:0;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.hn{padding:2px 8px 2px 8px;}.ssr-plugin'
import '.ho{height:5px;}.ssr-plugin'
import '.bg{height:1px;}.ssr-plugin'
import '.hp{width:2px;}.ssr-plugin'
import '.hq{height:2px;}.ssr-plugin'
import '.hr{margin:auto 8px;}.ssr-plugin'
import '.gk{display:inline-block;}.ssr-plugin'
import '.ds{border-radius:4px;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { Style, styled } from 'inlines'

type SeparatorProps = {
  orientation?: 'horizontal' | 'vertical'
  variant?: 'line' | 'dot'
  style?: Style
}

function Separator({
  orientation = 'horizontal',
  variant = 'line',
  style,
}: SeparatorProps) {
  if (variant === 'line') {
    if (orientation === 'vertical') {
      return (
        <styled.div className="hj hk hl hm"
          style={{
            background: colors.neutral10,
            ...style,
          }}
        />
      )
    }
    return (
      <styled.div className="f hn ho"
        style={{
          ...style,
        }}
      >
        <div className="bg f"
          style={{ background: colors.neutral10 }}
        />
      </styled.div>
    )
  } else {
    return (
      <styled.div className="hp hq hr gk ds hm"
        style={{
          background: colors.neutral60,
          // margin:'auto 6px',
          ...style,
        }}
      />
    )
  }
}

export { Separator }
export type { SeparatorProps }
